<template>
  <div class="card border-0 mt-5" v-if="product">
    <h3 class="card-header border-0 bg-secondary">
      Detalles de
      <strong>{{ product.name }}</strong>
      <br />
      <small class="text-muted text-xs">Producto seleccionado</small>
    </h3>
    <div class="card-body m-0 p-0 pt-3">
      <div class="row">
        <div class="col-lg-4 col-sm-4" v-if="actions.post || actions.put">
          <div class="card">
            <div
              class="card-header bg-success text-white"
              v-text="detail.id > 0 ? 'Editar detalle del producto':'Agregar nuevo detalle al producto'"
              :class="detail.id > 0 ? 'bg-info':'bg-success'"
            ></div>
            <div class="card-body">
              <form class="mb-10" @submit.prevent="handleSetDetail">
                <div class="alert alert-secondary shadow" v-if="!detail.active">
                  <i class="fa fa-exclamation-triangle mr-2 text-danger fadeIn"></i>
                  El detalle está inactivo
                  <template
                    v-if="tmpDetail.active != detail.active"
                  >
                    <br />
                    <span class="text-muted text-xs">Debes guardar cambios para hacerlo efectivo</span>
                  </template>
                </div>
                <div class="form-group mb-2">
                  <label for class="text-xs">Nombre</label>
                  <input
                    type="text"
                    maxlength="150"
                    class="form-control"
                    placeholder="Nombre descriptivo"
                    v-model="detail.name"
                    required
                  />
                  <span class="text-muted text-xs">El nombre requerido</span>
                </div>
                <div class="form-group mb-2">
                  <label for class="text-xs">Cantidad</label>
                  <input
                    type="number"
                    min="0"
                    class="form-control"
                    placeholder="Cantidad de avisos"
                    v-model="detail.quantity"
                  />
                  <span
                    class="text-muted text-xs"
                    :class="{'text-danger': detail.quantity < 0}"
                  >Ingresa una cantidad mayor a cero</span>
                </div>
                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input
                    
                      v-model="detail.active"
                      class="custom-control-input"
                      id="customCheck4"
                      type="checkbox"
                    />
                    <label class="custom-control-label" for="customCheck4">Activo</label>
                  </div>
                </div>
                <div class="form-group m-0 text-right">
                  <div
                    v-if="errorDetail"
                    class="alert alert-danger text-xs p-2"
                  >Error al procesar información</div>
                  <button
                    v-if="detail.quantity != 0 || detail.name.trim().length > 0"
                    type="button"
                    class="btn btn-link"
                    @click="cancelDetail"
                  >Cancelar</button>
                  <button
                    class="btn btn-success"
                    v-text="detail.id > 0 ? 'Actualizar':'Agregar'"
                    :class="detail.id > 0 ? 'btn-info':'btn-success'"
                    type="submit"
                    :disabled="!validDetail"
                  ></button>
                </div>
              </form>
            </div>
          </div>

          <div class="card card-body shadow text-muted text-xs mt-3" v-if="detail.id > 0">
            <p class="text-dark m-0 mb-2">Detalles</p>
            <p class="m-0 text-xs text-primary">Creado por:</p>
            <span>{{detail.user}}</span>
            <p class="m-0 text-xs text-primary">Fecha:</p>
            <span class="text-capitalice">{{detail.create_date | formatDate}}</span>
            <template v-if="detail.update_user">
              <hr class="m-0 text-xs my-2 text-muted" />
              <p class="m-0 text-xs text-primary">Editado por:</p>
              <span>{{detail.update_user}}</span>
              <p class="m-0 text-xs text-primary">Fecha:</p>
              <span class="text-capitalice">{{detail.update_date | formatDate}}</span>
            </template>
          </div>
        </div>
        <div :class="actions.post || actions.put ? 'col-lg-8 col-sm-8':'col-lg-12 col-sm-12'">
          <div class="card card-body p-0 border-0">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead class="bg-secondary font-weight-bold">
                  <tr>
                    <td>Nombre</td>
                    <td>Cant.</td>
                    <td>Fecha Creación</td>
                    <td></td>
                    <td></td>
                  </tr>
                </thead>
                <tbody class="text-muted">
                  <tr v-if="product.details.length == 0">
                    <td colspan="6">No hay detalles en este producto</td>
                  </tr>
                  <template v-for="(d, detailIndex) in product.details">
                    <tr
                      :class="{'bg-info text-white': d.id == detail.id}"
                      :key="'detailKey'+detailIndex"
                    >
                      <td>{{d.name}}</td>
                      <td>{{d.quantity}}</td>
                      <td>{{d.create_date | formatDate}}</td>
                      <td>
                        <span
                          class="badge"
                          :class="d.active ? 'badge-success':'badge-danger'"
                          v-text="d.active ? 'Activo':'Inactivo'"
                        ></span>
                      </td>
                      <td>
                        <button
                          v-if="actions.put"
                          type="button"
                          v-b-tooltip.hover
                          title="Editar"
                          class="btn btn-sm"
                          :disabled="d.id == detail.id || loadingDetail"
                          :class="d.id == detail.id ? 'btn-info':'btn-secondary'"
                          @click="selectedDetail(d)"
                        >
                          <i class="fa fa-edit"></i>
                        </button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ProductDetail } from "./models/model";
import Auth from "@/helpers/middleware";
import utils from "@/helpers/utils";
import dealersService from "@/services/dealers.services";
import sysMsgs from "@/helpers/system.message";

export default {
  name: "ProductDetails",
  props: ["product", "actions"],
  data() {
    return {
      loadingDetail: false,
      detail: new ProductDetail(Auth.getUser().email, this.product.id),
      errorDetail: false,
      tmpDetail: {}
    };
  },
  computed: {
    validName() {
      return this.detail.name.trim().length > 0;
    },
    validQuantity() {
      return this.detail.quantity > 0;
    },
    validDetail() {
      return this.validQuantity && this.validName;
    }
  },
  filters: {
    formatDate(val) {
      return utils.formatDateTime(val);
    }
  },
  methods: {
    selectedDetail(item) {
      this.detail = { ...item };
      this.tmpDetail = { ...item };
    },
    cancelDetail() {
      this.errorDetail = false;
      this.detail = new ProductDetail(Auth.getUser().email, this.product.id);
      this.tmpDetail = new ProductDetail(Auth.getUser().email, this.product.id);
    },
    handleSetDetail() {

      if (this.product.details.some(item => item.quantity == this.detail.quantity && item.id != this.detail.id)) {
        sysMsgs.getMessage(
          "Ya existe un detalle con iguales cantidades.",
          "error"
        );
        return;
      }

      if (!this.validDetail) {
        sysMsgs.getMessage(
          "Verifíca todos los campos antes de guardar.",
          "error"
        );
        return;
      }


      let msg = {};
      msg.text = this.detail.id == 0 ? "crear un nuevo" : "editar el";
      msg.type = this.detail.id == 0 ? "question" : "warning";
      sysMsgs
        .getConfirm(
          `¿Está seguro que quiere ${msg.text} detalle?`,
          msg.type,
          "Confirmar acción"
        )
        .then(result => {
          if (result.value) {
            this.detail.user = Auth.getUser().email;
            this.setDetail();
          }
        });
    },
    setDetail() {
      this.loadingDetail = true;
      const _this = this;
      dealersService.admin
        .SetProductDetail(this.detail)
        .then(response => {
          if (this.detail.id > 0) {
            let details = _this.product.details;
            let detailIndex = _this.product.details.findIndex(
              detail => detail.id == _this.detail.id
            );
            details[detailIndex] = { ...response.data };
            _this.detail = response.data;
            _this.tmpDetail = response.data;
            _this.details = [...details];

            sysMsgs.getMessage("Actualizado con éxito.", "success");
          } else {
            /* _this.detail = response.data;
            _this.tmpDetail = response.data; */
            _this.product.details.push(response.data);
            _this.cancelDetail()
            sysMsgs.getMessage("Agregado con éxito.", "success");
          }
          _this.errorDetail = false;
        })
        .catch(error => {
          console.log("error", error);
          this.errorDetail = true;
          sysMsgs.getResponseMessage(error.response);
        })
        .finally(() => {
          this.loadingDetail = false;
        });
    }
  }
};
</script>